import { Injector, ModuleWithProviders, NgModule, inject } from '@angular/core';
import { NavigationBarService } from './navigation-bar.service';
import { navigationBarServiceFactory } from './navigation-bar-service.factory';
import { PlatformDetectionService } from '@libs/util/shared';
import { ColorCalculationsService } from '@libs/core/color';

@NgModule()
export class NavigationBarModule {
  static injector: Injector;

  constructor() {
    const module = inject(NavigationBarModule, { optional: true, skipSelf: true });
    const injector = inject(Injector);

    if (module) {
      throw new Error(`${NavigationBarModule.name} should be imported only once!`);
    }

    NavigationBarModule.injector = injector;
  }

  static forRoot(): ModuleWithProviders<NavigationBarModule> {
    return {
      ngModule: NavigationBarModule,
      providers: [
        {
          provide: NavigationBarService,
          useFactory: navigationBarServiceFactory,
          deps: [PlatformDetectionService, ColorCalculationsService],
        },
      ],
    };
  }
}
